import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dincharya',
  templateUrl: './dincharya.component.html',
  styleUrls: ['./dincharya.component.scss']
})
export class DincharyaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  // timelineEvents = [
  //   { title: 'Waking up', time: '5.00 AM', image: 'assets/img/Wakeup Bell.png' },
  //   { title: 'Power Yoga', time: '5.15–6.00 AM', image: 'assets/img/Yoga.png' },
  //   { title: 'Disease Specific Yoga', time: '6.00–6.45 AM', image: 'assets/img/Yoga.png' },
  //   { title: 'Herbal Tea', time: '7.00–7.30 AM', image: 'assets/img/Herbal Tea.png' },
  //   { title: 'Massage & Hydrotherapy', time: '7.30–10.30 AM', image: 'assets/img/Massage.png' },
  //   { title: 'Juices', time: '8.00–9.00 AM', image: 'assets/img/Juice.png' },
  //   { title: 'Naturopathy Lunch', time: '10.30–12.00 PM', image: 'assets/img/Lunch.png' },
  //   { title: 'Rest', time: '12.00–2.15 PM', image: 'assets/img/Rest.png' },
  //   { title: 'Disease Specific Yoga', time: '2.15–2.45 PM', image: 'assets/img/Yoga.png' },
  //   { title: 'Herbal Tea', time: '3.00–3.15 PM', image: 'assets/img/Herbal Tea.png' },
  //   { title: 'Hydrotherapy', time: '3.00–5.00 PM', image: 'assets/img/Treatment.png' },
  //   { title: 'Juices', time: '4.00–4.30 PM', image: 'assets/img/Juice.png' },
  //   { title: 'Health Discourses', time: '4.30–5.30 PM', image: 'assets/img/Meditation.png' },
  //   { title: 'Dinner', time: '5.30–6.30 PM', image: 'assets/img/Dinner.png' },
  //   { title: 'Rest & Leisure', time: '6.30–7.15 PM', image: 'assets/img/Reading.png' },
  //   { title: 'Prayer', time: '7.15–7.45 PM', image: 'assets/img/Meditation.png' },
  //   { title: 'Meditation/Trataka', time: '7.45–8.30 PM', image: 'assets/img/Meditation.png' },
  //   { title: 'Recreation & Leisure', time: '8.30–9.30 PM', image: 'assets/img/Walking.png' },
  //   { title: 'Bed Time', time: '9.30 PM', image: 'assets/img/Rest.png' },
  // ];


}
